const businessDiagnosisDictEN = {
  businessDiagnosis: "Business Assessment",
  businessDiagnosisSubtitle:
    "Dear entrepreneur, in the following you will find a series of questions to make your company even more EFFICIENT, EFFECTIVE, ECONOMIC and SUSTAINABLE. Ingenuity, dedication, professionalism and sharing will help you take a unique path together.",

  businessDiagnosisMenuSelection: "Selection menu",

  businessDiagnosisInProgress: "Business Diagnosis on Hold",
  businessDiagnosisProgressDescription:
    "Discover how to make your company more affordable and sustainable.",
  businessDiagnosisProgressLabel: "Progress:",
  businessDiagnosisProgressStep: "Phase {current} of {total}",
  businessDiagnosisContinue: "Continue the Diagnosis",

  businessDiagnosisStep1Title: "Company Details",
  businessDiagnosisStep2Title: "Company Structure",
  businessDiagnosisStep3Title: "Company Size",
  businessDiagnosisStep4Title: "Human Capital by Gender",
  businessDiagnosisStep5Title: "Human Capital by Roles",
  businessDiagnosisStep6Title: "Human Capital",
  businessDiagnosisStep7Title: "Representations",
  businessDiagnosisStep8Title: "Other Information",

  businessDiagnosisStep1Description:
    "Enter the general data of your company to help us understand your identity and the context in which you operate.",
  businessDiagnosisStep2Description:
    "Describe the composition and internal organization of your company to understand its strength and operating capacity.",
  businessDiagnosisStep3Description:
    "Specify the size of your company so we can better evaluate your needs and growth potential.",
  businessDiagnosisStep4Description:
    "Tell us how many employees your company has and their skills, in order to enhance your human capital.",
  businessDiagnosisStep5Description:
    "Specify the main roles and responsibilities of your employees, highlighting the key positions for the company's growth.",
  businessDiagnosisStep6Description:
    "Enter data related to the personnel employed in your company, broken down by roles, skills and operational areas.",
  businessDiagnosisStep7Description:
    "Provide information about any legal or commercial representatives of your company, both at national and international level.",
  businessDiagnosisStep8Description:
    "Explain how your company uses technological tools and innovative strategies to remain competitive.",

  back: "Back",
  saveAndContinue: "Save & continue",
  sendDiagnosis: "Send Diagnosis",

  businessDiagnosisConsent: "I consent",
  businessDiagnosisConsentText:
    "I consent to the use of the information provided for a free assessment for the EXTRACONOMY platform and authorize the processing of data in accordance with current legislation and GDPR.",

  // Shared helpers
  select: "Select",
  businessDiagnosisNoData: "—",

  // Step 1
  businessDiagnosisStep1LabelCompanyName: "Company Name",
  businessDiagnosisStep1LabelRegisteredOffice: "Registered Office",
  businessDiagnosisStep1LabelAddress: "Address",
  businessDiagnosisStep1LabelVatNumber: "VAT Number",
  businessDiagnosisStep1LabelAtecoCode: "ATECO Code",
  businessDiagnosisStep1LabelSector: "Sector",
  businessDiagnosisStep1LabelLegalRepresentative: "Legal Representative",
  businessDiagnosisStep1LabelPhone: "Phone",
  businessDiagnosisStep1LabelAdministrativeRepresentative: "Administrative Representative",
  businessDiagnosisStep1LabelWebsite: "Website",
  businessDiagnosisStep1PlaceholderWebsite: "https://",
  businessDiagnosisStep1LabelEmail: "E-mail",
  businessDiagnosisStep1LabelCompanyDescription: "Brief description of the company",
  businessDiagnosisStep1PlaceholderCompanyDescription:
    "Brief description of the mission and activities.",
  businessDiagnosisStep1LabelLawFirm: "Law Firm",
  businessDiagnosisStep1LabelAccountingFirm: "Accounting Firm",
  businessDiagnosisStep1LabelLaborConsultant: "Labor Consultant",

  // Step 2
  businessDiagnosisStep2OrganizationalChartLabel: "Organizational chart",
  businessDiagnosisStep2OrganizationalChartHelp: "Does the company have an organizational chart?",
  businessDiagnosisStep2CompanyRegulationsLabel: "Company regulations",
  businessDiagnosisStep2CompanyRegulationsHelp: "Is there an internal regulation?",
  businessDiagnosisStep2OrganizationalModel231Label: "Organizational Model 231/01",
  businessDiagnosisStep2OrganizationalModel231Help: "Adopt Model 231/01?",
  businessDiagnosisStep2ModelOt23Label: "OT23 - ISI INAIL Model",
  businessDiagnosisStep2ModelOt23Help: "Does the company apply OT23/INAIL models?",
  businessDiagnosisStep2CodeOfEthicsLabel: "Code of Ethics",
  businessDiagnosisStep2CodeOfEthicsHelp: "Does the company have a code of ethics?",
  businessDiagnosisStep2LegalityRatingLabel: "Legality Rating",
  businessDiagnosisStep2LegalityRatingHelp: "Has it obtained a legality rating?",
  businessDiagnosisStep2SustainabilityReportLabel: "Sustainability Report",
  businessDiagnosisStep2SustainabilityReportHelp: "Publishes sustainability reports?",
  businessDiagnosisStep2SecondaryOfficesLabel: "Secondary offices",
  businessDiagnosisStep2SecondaryOfficesHelp: "Are there secondary offices?",
  businessDiagnosisStep2SecondaryOfficesWhere: "If yes, specify where",
  businessDiagnosisStep2IndustryAssociationLabel: "Membership in industry associations",
  businessDiagnosisStep2IndustryAssociationHelp: "Membership in industry associations.",
  businessDiagnosisStep2IndustryAssociationWhich: "If yes, specify which",
  businessDiagnosisStep2InterprofessionalFundsLabel: "Interprofessional Funds",
  businessDiagnosisStep2InterprofessionalFundsHelp: "Participation in interprofessional funds.",
  businessDiagnosisStep2InterprofessionalFundsWhich: "If yes, specify which one(s)",
  businessDiagnosisStep2BilateralEntityLabel: "Bilateral Entity",
  businessDiagnosisStep2BilateralEntityHelp: "Is it registered with a bilateral entity?",
  businessDiagnosisStep2BilateralEntityWhich: "If yes, specify which",

  // Step 3
  businessDiagnosisStep3LabelEmployees: "Number of Employees",
  businessDiagnosisStep3EmployeesHelp: "Indicate the company size based on employees.",
  businessDiagnosisStep3LabelRevenue: "Annual Turnover",
  businessDiagnosisStep3RevenueHelp: "Indicate the annual revenue bracket.",

  businessDiagnosisSizeEmployeesMicro: "Micro enterprise (<10)",
  businessDiagnosisSizeEmployeesSmall: "Small enterprise (10-49)",
  businessDiagnosisSizeEmployeesMedium: "Medium enterprise (50-249)",
  businessDiagnosisSizeEmployeesLarge: "Large enterprise (250+)",

  businessDiagnosisSizeRevenueLte2: "Up to 2 million",
  businessDiagnosisSizeRevenue2To10: "2 to 10 million",
  businessDiagnosisSizeRevenue10To50: "10 to 50 million",
  businessDiagnosisSizeRevenueGt50: "More than 50 million",

  // Step 4
  businessDiagnosisStep4LabelTotalEmployees: "Total number of employees",
  businessDiagnosisStep4LabelWomen: "Women",
  businessDiagnosisStep4GenderDistributionHelp: "Gender distribution.",
  businessDiagnosisStep4LabelMen: "Men",
  businessDiagnosisStep4LabelOtherGender: "Other gender",

  // Step 5
  businessDiagnosisStep5InternalHrLabel: "Internal H.R.",
  businessDiagnosisStep5InternalHrHelp:
    "Indicate if there is an internal HR office or responsible person.",
  businessDiagnosisStep5SecondLevelContractLabel: "Second-level contract",
  businessDiagnosisStep5SecondLevelContractHelp:
    "Indicate if the company applies second-level contracts (integrations to the CCNL).",
  businessDiagnosisStep5OngoingLaborDisputesLabel: "Ongoing labor disputes",
  businessDiagnosisStep5OngoingLaborDisputesHelp:
    "Indicate if there are labor disputes currently ongoing.",
  businessDiagnosisStep5ConcludedLaborDisputesLabel: "Concluded labor disputes",
  businessDiagnosisStep5ConcludedLaborDisputesHelp:
    "Indicate if the company has concluded labor disputes in the past.",
  businessDiagnosisStep5UnionRepresentativesLabel: "Union representatives",
  businessDiagnosisStep5UnionRepresentativesHelp:
    "Indicate if there are active union representatives in the company.",
  businessDiagnosisStep5UnionRepresentativesWhichLabel: "If yes, specify which",
  businessDiagnosisStep5UnionRepresentativesWhichHelp:
    'If you answered "YES" above, specify which contracts, disputes or representatives.',
  businessDiagnosisStep5AppliedCcnlLabel: "CCNL applied",
  businessDiagnosisStep5AppliedCcnlPlaceholder:
    "Indicate which CCNL (National Collective Labor Agreement) is applied in the company.",

  // Step 6
  businessDiagnosisStep6StaffingAgenciesLabel: "Use of Employment Agencies",
  businessDiagnosisStep6StaffingAgenciesHelp:
    "Indicate if the company uses external agencies for selection and staff management.",
  businessDiagnosisStep6DirectSeveranceLabel: "Direct management of severance pay (TFR)",
  businessDiagnosisStep6DirectSeveranceHelp:
    "Indicate if the company manages internally the employees' severance pay (Trattamento di Fine Rapporto).",
  businessDiagnosisStep6UseTfmLabel: "Use of TFM policies",
  businessDiagnosisStep6UseTfmHelp:
    "Specify if the company uses TFM policies (Trattamento di Fine Mandato) for managers.",
  businessDiagnosisStep6UseKmanLabel: "Use of KMAN policies",
  businessDiagnosisStep6UseKmanHelp:
    "Indicate if KMAN insurance policies are active for key company figures.",
  businessDiagnosisStep6CorporateWelfareLabel: "Corporate Welfare",
  businessDiagnosisStep6CorporateWelfareHelp:
    "Indicate if the company offers a corporate welfare plan (benefits and services for employees).",
  businessDiagnosisStep6HealthWelfareLabel: "Healthcare Welfare",
  businessDiagnosisStep6HealthWelfareHelp:
    "Indicate if the company offers healthcare welfare insurance or services to employees.",

  // Step 7
  businessDiagnosisStep7RsaLabel: "RSA - Company Union Representative",
  businessDiagnosisStep7RsaHelp:
    "Indicate if the company has a union representative for union members only.",
  businessDiagnosisStep7RsuLabel: "RSU - Unitary Union Representative",
  businessDiagnosisStep7RsuHelp:
    "Indicate if there is a representative that protects all workers, union members and non-members.",
  businessDiagnosisStep7RpsLabel: "RPS - Representative for Safety",
  businessDiagnosisStep7RpsHelp: "Specify if employees have appointed a safety representative.",
  businessDiagnosisStep7RsppLabel: "RSPP - Safety and Prevention Officer",
  businessDiagnosisStep7RsppHelp:
    "Indicate if the employer has appointed a responsible person for safety and prevention.",
  businessDiagnosisStep7RsppNameLabel: "RSPP name (indicate)",
  businessDiagnosisStep7RsppNamePlaceholder: "Write the name of the person appointed as RSPP.",
  businessDiagnosisStep7DvrLabel: "DVR - Risk Assessment Document",
  businessDiagnosisStep7DvrHelp: "Risk assessment document.",
  businessDiagnosisStep7DuvriLabel: "DUVRI - Single Interference Risk Assessment Document",
  businessDiagnosisStep7DuvriHelp:
    "Indicate if the document assessing risks arising from third-party activities on site is present.",

  // Step 8
  businessDiagnosisStep8LabelSocialMediaPresence: "Presence on social media",
  businessDiagnosisStep8LabelECommerce: "E-commerce",
  businessDiagnosisStep8LabelGenderEqualityCertification: "Gender Equality Certification",
  businessDiagnosisStep8LabelIso: "ISO",
  businessDiagnosisStep8IsoWhichLabel: "If yes, specify which",
  businessDiagnosisStep8LabelCyberSecurity: "Cyber security",
  businessDiagnosisStep8LabelGdpr: "GDPR",
  businessDiagnosisStep8LabelSubsidizedFinance: "Use of Subsidized Finance",
  businessDiagnosisStep8LabelFundedTraining: "Use of Funded Training",
  businessDiagnosisStep8LabelHasLiquidityManager: "Do you have a company liquidity manager?",
  businessDiagnosisStep8LabelDiversifiedLiquidityWithGold:
    "Have you diversified company liquidity by purchasing gold?",
  businessDiagnosisStep8LabelDate: "Date: ",
  businessDiagnosisStep8LabelConsultant: "Consultant: ",
};

export default businessDiagnosisDictEN;
